<script setup lang="ts">
import { useAuth } from '@/composables/useAuth'
import { useStorage } from '@vueuse/core'

const version = useStorage<string | null>('version', null)
const { logout } = useAuth()

onMounted(() => {
  const currentVersion = import.meta.env.VITE_VERSION
  if (version.value && currentVersion !== version.value) {
    logout()
  }
  version.value = currentVersion
})
</script>

<template>
  <div class="bg-background h-screen">
    <RouterView v-slot="{ Component }">
      <Transition name="fade" mode="out-in">
        <component :is="Component" />
      </Transition>
    </RouterView>
  </div>
</template>
